<template>
    <div>
        <el-tooltip effect="dark" content="大屏显示" placement="bottom">
            <el-button class="d2-ml-0 d2-mr btn-text can-hover" type="text" @click="gotoBigScreen">
                <d2-icon name="television" style="font-size: 16px"/>
            </el-button>
        </el-tooltip>
    </div>
</template>

<script>
  export default {
    methods: {
      gotoBigScreen(){
        this.$router.push({path:"/guoguan-home"})
      }
    }
  }
</script>

